import { useState } from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialUiButton from "../Buttons/MaterialUiButton/MaterialUiButton"
import Modal from "@mui/material/Modal";

export default function ImageModal(props) {
  const { modalOpen, setModalOpen, image } = props;
  const { preview, name } = image;
  const classes = {
    container: {
      textAlign: "center",
      padding: "1rem 0;",
    },
    image: {
      width: "100%",
    },
    paper: (theme)=>({
      position: "absolute",
      width: 400,
      backgroundColor: theme?.palette?.background?.paper,
      border: "2px solid #000",
      boxShadow: theme?.shadows[5],
      padding: theme?.spacing(2, 4, 3),
    })
  }
  // Modal Test stuff
  function rand() {
    return Math.round(Math.random() * 20) - 10;
  }
  function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }
  const [modalStyle] = useState(getModalStyle);

  const body = (
    <Box style={modalStyle} className={classes.paper}>
      <Grid container>
        <Grid sx={classes.container} size={12}>
          {name}
        </Grid>
        <Grid sx={classes.container} size={12}>
          <img src={preview} style={classes.image} alt="preview" />
        </Grid>
        <Grid sx={classes.container} size={12}>
          <MaterialUiButton
            color="primary"
            fullWidth={true}
            label="Close"
            onClick={() => {
              setModalOpen(false);
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <Modal
      open={modalOpen}
      onClose={() => {
        setModalOpen(false);
      }}
      aria-describedby="simple-modal-description"
      aria-labelledby="simple-modal-title"
    >
      {body}
    </Modal>
  );
}
